module.exports = __webpack_public_path__ + "static/media/songify.eb7532ca.png";